import React from 'react';

export default () => {
  return (
    <>
      <p className="handler-title">
        Buscar produto do catalógo VTex
      </p>

      <div className="common-form-group">
        <label>Informações do produto serão salvas em:</label>
        <input
          className="form-control mt-1"
          defaultValue="vtex.selectedProduct"
          disabled
        />
      </div>
    </>
  );
};
